import Colors from "styles/colors";
import SideBySideTabsAndProcessTabs from "segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/side-by-side-tabs-and-process-tabs";
import { componentStyles } from "./side-by-side-tabs-and-process-tabs-component.scss";

const SideBySideTabsAndProcessTabsMobileComponent = ({ selectedTabBackgroundColor, ...rest }) => (
  <div
    className="side-by-side-tabs-and-process-tabs-mobile-component"
    style={{ "--selected-tab-background-color": Colors[selectedTabBackgroundColor] }}
  >
    <SideBySideTabsAndProcessTabs {...rest} />
    <style jsx>{componentStyles}</style>
  </div>
);

export default SideBySideTabsAndProcessTabsMobileComponent;
